export enum ResidenceStatus {
  Undefined = 'Undefined',
  MovedIn = 'MovedIn',
  MovedOut = 'MovedOut',
}
